import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { environment } from 'src/environments/environment';
import { CompetitionsSharedModule } from 'src/app/modules/competitions/shared/shared.module';
import { ProjectsModule } from 'src/app/modules/projects/projects.module';
import {
  AmplitudeModule,
  NoopAmplitudeModule
} from 'src/app/shared/modules/amplitude';
import {
  AppHideForModule,
  AppRouterLinkModule,
  AppLinksModule
} from 'src/app/shared/modules';

import { GroupsRoutingModule } from './groups-routing.module';
import { GroupsContainerComponent } from './groups-container/groups-container.component';
import { GroupItemComponent } from './group-item/group-item.component';
import { GroupViewComponent } from './group-view/group-view.component';
import { GroupViewMemberComponent } from './group-view-member/group-view-member.component';
import { SharedModule } from './../../shared/shared.module';
import * as fromPost from '../../shared/ui/post/data/store/reducer';
import { PostEffects } from '../../shared/ui/post/data/store/effects';
import { postsFeatureKey } from '../../shared/ui/post/data/store/state';
import { GroupMenuComponent } from './menu/group-menu.component';
import { ClubContainerComponent } from './club-container/club-container.component';
import { ClubMembersComponent } from './club-container/club-members/club-members.component';
import { ClubRequestsComponent } from './club-container/club-requests/club-requests.component';
import { ClubMediaPhotosComponent } from './club-container/club-media/club-media-photos/club-media-photos.component';
import { ClubMediaVideosComponent } from './club-container/club-media/club-media-videos/club-media-videos.component';
import { ClubMediaFilesComponent } from './club-container/club-media/club-media-files/club-media-files.component';
import { ClubResourcesComponent } from './club-container/club-resources/club-resources.component';
import { ClubMediaPhotosSectionComponent } from './club-container/club-media/club-media-photos/club-media-photos-section/club-media-photos-section.component';
import { ClubMediaFilesSectionComponent } from './club-container/club-media/club-media-files/club-media-files-section/club-media-files-section.component';
import { GroupsCategoriesComponent } from './groups-categories/groups-categories.component';
import { BusinessOrgItemComponent } from './business-org-item/business-org-item.component';
import { BusinessClubItemComponent } from './business-club-item/business-club-item.component';
import { SideBarMenuComponent } from './side-bar-menu/side-bar-menu.component';

@NgModule({
  declarations: [
    GroupsContainerComponent,
    GroupItemComponent,
    GroupViewComponent,
    GroupViewMemberComponent,
    GroupMenuComponent,
    ClubContainerComponent,
    ClubMembersComponent,
    ClubRequestsComponent,
    ClubMediaPhotosComponent,
    ClubMediaVideosComponent,
    ClubMediaFilesComponent,
    ClubResourcesComponent,
    ClubMediaPhotosSectionComponent,
    ClubMediaFilesSectionComponent,
    GroupsCategoriesComponent,
    BusinessOrgItemComponent,
    BusinessClubItemComponent,
    SideBarMenuComponent
  ],
  imports: [
    InfiniteScrollModule,
    CommonModule,
    ProjectsModule,
    AppHideForModule,
    AppRouterLinkModule,
    AppLinksModule,
    SharedModule,
    environment.production
      ? AmplitudeModule.forRoot(environment.amplitude)
      : NoopAmplitudeModule,
    CompetitionsSharedModule,
    GroupsRoutingModule,
    StoreModule.forFeature(postsFeatureKey, fromPost.postsReducer),
    EffectsModule.forFeature([PostEffects])
  ],
  exports: [BusinessClubItemComponent]
})
export class GroupsModule {}
